module.exports = __webpack_public_path__ + "static/00001.d16da1a8.jpg";